import * as React from 'react';
import Control from 'react-leaflet-control';
import * as moment from 'moment/moment';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

const styles: StyleRulesCallback = theme => ({
  wrapper: {}
});

type SceneClick = (scene: SceneDocument) => void;

interface SceneCircleProps {
  scene: SceneDocument;
  x: number;
  onClick: () => void;
  selected: boolean;
}

interface Props {
  position?: 'bottomleft' | 'bottomright' | 'topleft' | 'topright';
  scenes?: SceneDocument[];
  onSceneClick: SceneClick;
  selectedId?: string | null;
  width?: number | null;
}

function formatDateLabel(scene: SceneDocument) {
  return moment.unix(parseInt(scene.capturedOn, 10) / 1000).format('DD/MM/YY');
}

const MARGIN = 40;
const CELL_WIDTH = 60;
const HALF_CELL_WIDTH = CELL_WIDTH / 2;
const HEIGHT = 80;
const HALF_HEIGHT = HEIGHT / 2;

const SceneCircle = ({ scene, x, onClick, selected }: SceneCircleProps) => (
  <svg x={x} height={HEIGHT} width={CELL_WIDTH}>
    <circle
      cx={HALF_CELL_WIDTH}
      cy={HALF_HEIGHT}
      r="13"
      fill={selected ? '#ff1744' : '#04DA83'}
      onClick={onClick}
    />
    <rect fill="#fff" x={0} y={HEIGHT - 20} width={CELL_WIDTH} height={20} />
    <text textAnchor="middle" fontSize={14} y={HEIGHT - 5} x={HALF_CELL_WIDTH}>
      {formatDateLabel(scene)}
    </text>
  </svg>
);

class SceneTimeline extends React.Component<Props & WithStyles> {
  render() {
    const { scenes, position, onSceneClick, selectedId, width } = this.props;

    if (!scenes || !scenes.length) {
      return null;
    }

    let TOTAL_WIDTH = width || 900;

    const gutter =
      (TOTAL_WIDTH - CELL_WIDTH - MARGIN - MARGIN) / (scenes.length - 1);

    return (
      <Control position={position || 'bottomleft'}>
        <svg width={TOTAL_WIDTH} height={HEIGHT}>
          <line
            x1={MARGIN + HALF_CELL_WIDTH}
            y1={HALF_HEIGHT}
            x2={TOTAL_WIDTH - HALF_CELL_WIDTH - MARGIN}
            y2={HALF_HEIGHT}
            strokeWidth="8"
            stroke="#fff"
          />
          {scenes.map((scene, index) => (
            <SceneCircle
              key={scene.id}
              selected={scene.id === selectedId}
              scene={scene}
              x={MARGIN + index * gutter}
              onClick={() => onSceneClick(scene)}
            />
          ))}
        </svg>
      </Control>
    );
  }
}

export default withStyles(styles)(SceneTimeline);



// WEBPACK FOOTER //
// ./src/components/SceneTimeline.tsx